import React,{useContext} from 'react';
import UserContext from "../Context/AppContext"
import { Drawer,List,ListItem,ListItemIcon,ListItemText,Divider,Tooltip  } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SettingsSharpIcon from '@material-ui/icons/SettingsSharp';
import RateReviewIcon from '@material-ui/icons/RateReview';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import Zoom from '@material-ui/core/Zoom';
import { useHistory } from 'react-router-dom';
import { auth } from '../Utils/api';

const MenuOptions=
[
    {icon:<ListIcon/>,label:"Lista de espera",path:"/admin"},
    {icon:<MenuBookIcon/>,label:"Menú",path:"/admin/menu"},
    {icon:<RateReviewIcon/>,label:"Reseñas",path:"/admin/reseñas"},
    {icon:<SettingsSharpIcon/>,label:"Configuración",path:"/admin/configuracion"},
]

const StyleButton=
{
    cursor:"pointer",
    position:"fixed",
    bottom:10,
    left:10,
    fontSize:"40px"
}

const DrawerMenu = ({open,close}) => 
{
    const History=useHistory();

    const handleCloseSession=async ()=>
    {
       await auth.signOut();
       History.push("/login");
    }

    return (
        <Drawer open={open} onClose={close}>
            <List>
            {MenuOptions.map(ruta =>
                {
                    const {label,icon,path}=ruta

                    const handleClick=()=>
                    {
                        History.push(`${path}`)
                    }

                    
                    return (<>
                    <ListItem key={label} button onClick={handleClick}>
                        <ListItemIcon>{icon}</ListItemIcon>
                        <ListItemText>{label}</ListItemText>
                    </ListItem>
                    <Divider/>
                    </>)
                })}
            </List>
           <Tooltip title="Cerrar sesión" arrow TransitionComponent={Zoom} TransitionProps={{ timeout: 150 }}>
            <ExitToAppIcon onClick={handleCloseSession} style={StyleButton}/>
           </Tooltip >
        </Drawer>
    )
}

export default DrawerMenu
